import cloneDeep from 'lodash/cloneDeep'

export default {
  state: {
    items: [],
    editedItem: null,
    autoIncrement: 1,
    saveMessage: '',
  },
  getters: {
    emptyPrintLocations: (state) => {
      if (!state.editedItem) return []
      return state.editedItem.printLocations.filter((location) => {
        return location.technology.allowsColorPick && location.calculations.totalSelectedColorsNumber < 1
      })
    },
  },
  mutations: {
    updateCartItem(state, { item, propsToUpdate }) {
      for (let prop in propsToUpdate) {
        item[prop] = propsToUpdate[prop]
      }
    },
    restoreCartItem(state, item) {
      item = Object.assign(item, item.backup)
      item.backup = null
    },
    createCartItem(state,  { type, model }) {
      let item
      const base = {
        virtualId: null,
        type,
        model,
        color: null,
        prices: {
          max: 0,
          current: 0,
        },
        printLocations: [],
        backup: null,
        calculations: {
          totals: null,
          total: null,
        },
      }
      if (type.id === 'bags') {
        item = {
          sizes: [],
          density: null,
        }
      } else {
        item = {
          number: 1,
          pack: false,
        }
      }
      state.editedItem = { ...base, ...item }
    },
    editCartItem(state, item) {
      state.editedItem = cloneDeep(item)
    },
    addCartItem(state) {
      state.editedItem.virtualId = state.autoIncrement
      state.items.push(state.editedItem)
      state.autoIncrement++
      state.lastSavedItem = state.editedItem
      state.lastSaveAction = 'add'
      state.editedItem = null
      state.saveMessage = 'Товар добавлен в корзину'
    },
    clearEditedCartItem(state) {
      state.editedItem = null
    },
    replaceCartItem(state) {
      const matchedItem = state.items.filter((item) => item.virtualId === state.editedItem.virtualId)[0]
      const index = state.items.indexOf(matchedItem)
      state.items.splice(index, 1, state.editedItem)
      state.lastSavedItem = state.editedItem
      state.lastSaveAction = 'update'
      state.editedItem = null
      state.saveMessage = `Изменения сохранены`
    },
    removeCartItem(state, index) {
      state.items.splice(index, 1)
    },
    removeCartItemById(state, id) {
      state.items = state.items.filter((item) => item.virtualId !== id)
      if (state.editedItem.virtualId === id) {
        state.editedItem = null
      }
    },
    clearSaveMessage(state) {
      state.saveMessage = ''
    },
  }
}